<template>
  <div class="flex-container" v-cLoading="pageLoading" style="margin-top: calc(50vh - 300px);overflow: hidden">
    <div class="hold-icon">
      <img v-asset="'loginHold'">
    </div>
    <div class="form-box login-form-container">
      <el-form :rules="rules" ref="ruleForm" :model="loginForm">
        <p class="title">{{ appName }}</p>
        <el-form-item prop="username">
          <el-input
            placeholder="输入用户名"
            class="login-field"
            v-model="loginForm.username"
          >
            <i style="font-size: 22px;" slot="prefix" class="iconfont icon-yonghu"></i>
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            placeholder="输入密码"
            class="login-field"
            @keyup.enter.native="login"
            :type="openPassword ? 'text' : 'password'"
            v-model="loginForm.password"
          >
            <i slot="prefix" class="iconfont icon-iconfontlock"></i>
            <i
              slot="suffix"
              class="iconfont"
              style="position:relative;top: 2px;cursor: pointer"
              @click="openPassword = !openPassword"
              :class="openPassword ? 'icon-yanjing' : 'icon-yanjing1'"
            ></i>
          </el-input>
        </el-form-item>
        <div class="operation">
          <el-checkbox v-model="rememberAccount">记住账号</el-checkbox>
          <el-button class="clickedWord" type="text" @click="forgetPassword">忘记密码</el-button>
        </div>
        <el-button class="login-btn" @click="login" size="large" type="primary">
          登
          <span style="margin-left: 15px">录</span>
        </el-button>
        <el-form-item>
          <div class="register-line">
            <el-button class="clickedWord" type="text" @click="outsourceRegister">外包商备案</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <img :src="require('./back.png')" style="position: absolute;bottom: 0;width: 535px;right: 0;">
  </div>
</template>

<script>
import ApiUser from './../../apis/user'
import { accountValidator, passwordValidator } from '@/utils/validators'

export default {
  name: 'Login',
  data() {
    return {
      rules: {
        username: [{ validator: accountValidator, required: true }],
        password: [{ validator: passwordValidator, required: true }]
      },
      pageLoading: false,
      openPassword: false,
      rememberAccount: true,
      loginForm: {
        username: '',
        password: '',
        loginType: 1, //登录类型  0 手机号验证码   1 密码
        type: 1 //1企业  2工程师  3. 运营
      }
    }
  },
  computed: {
    theme: function() {
      return this.$store.state.app.theme
    },
    appName: function() {
      return this.$store.state.app.appName
    }
  },
  mounted() {
    //设置account
    const account = localStorage.getItem('account')
    if (account && !this.loginForm.username) {
      this.loginForm.username = account
    }
  },
  methods: {
    forgetPassword() {
      this.$router.push('/account/password_change')
    },
    //外包商注册
    outsourceRegister() {
      this.$router.push('/account/outsource_register')
    },
    verify() {
      let formValid
      this.$refs['ruleForm'].validate((valid) => {
        formValid = valid
      })
      return formValid
    },
    login() {
      if (!this.verify()) {
        return
      }
      this.pageLoading = true
      ApiUser.login({
        phone: this.loginForm.username,
        password: this.loginForm.password
      })
        .then((res) => {
          //记住账号
          this.pageLoading = false
          if (this.rememberAccount) {
            localStorage.setItem('account', this.loginForm.username)
          } else {
            localStorage.removeItem('account')
          }
          this.$store.dispatch('LogBackByToken', res.token)
          this.$store.dispatch('InitUserRole', res.userTypeEnums || [])
          //如果判定为首次登录  则将这个信息缓存起来
          // res.firstLogin && this.$store.commit('SET_FIRST_LOGIN', true)

          // 这个地方是有点问题的，新需求，首次登录 跳转到 xxx 或者特定用户跳转到 xxx 写一个Action 处理登录跳转需求。
          //其实还是觉得 能把那个 路由拦截的
          this.$router.replace('/')
        })
        .catch((err) => {
          this.pageLoading = false
          err.errMsg && this.$message.error(err.errMsg)
        })
    }
  }
}
</script>
<style lang="scss">
.login-form-container {
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-radius: 50%;
    background-color: #4d7cff;
    border-color: #4d7cff;
    width: 19px;
    height: 19px;
    &:after {
      left: 7px;
      top: 4px;
    }
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #4d7cff;
  }
  .el-checkbox__input + .el-checkbox__label {
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #999999;
  }
  .clickedWord {
    font-family: PingFangSC-Regular, PingFang SC;
    text-decoration: underline;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #4d7cff;
  }
  .login-field {
    padding: 6px;
    height: 53px;
    background-color: #fff;
    border-radius: 10px;
    border: solid 1px #d5d5d5;
    .iconfont {
      line-height: 51px;
      height: 53px;
      padding: 6px 10px;
      font-size: 20px;
      color: #4d7cff;
      /*color: #333;*/
    }

    .el-input__inner {
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      &::placeholder {
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #cccccc;
      }
    }
    input {
      padding-left: 40px;
      padding-right: 40px;
      border: none;
      outline: none;
      background-color: #fff0;
      &:-webkit-autofill {
        -webkit-text-fill-color: #333 !important;
        transition: background-color 5000s ease-in-out 0s;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.flex-container {
  width: 1000px;
  height: 600px;
}
.hold-icon {
  flex: 1;
  box-sizing: border-box;
  img {
    width: 100%;
    height: 100%;
  }
}
.form-box {
  padding: 0 35px;
  overflow: hidden;
  margin: auto;
  width: 450px;
  flex: 1;
}
.form-box .title {
  text-align: center;
  font-weight: bold;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 33px;
  font-stretch: normal;
  line-height: 45px;
  letter-spacing: 7px;
  color: #4d7cff;
  margin-bottom: 50px;
}

.operation {
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
input:-webkit-autofill {
  -webkit-text-fill-color: #333 !important;
  transition: background-color 5000s ease-in-out 0s;
}

.login-btn {
  margin-top: 20px;
  width: 100%;
  line-height: 1.5;
  height: 48px;
  background-image: linear-gradient(90deg, #4cc7ff 0%, #4f2fff 100%), linear-gradient(#44bbff, #44bbff);
  background-blend-mode: normal, normal;
  border-radius: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #ffffff;
  border-width: 0;
}
.register-line {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue